import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { appsAPI } from '../services/api';
import './Dashboard.css';

const Dashboard = () => {
  const { user, refreshUser } = useAuth();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ totalApps: 0, totalTests: 0 });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await appsAPI.list();
      setApps(response.data);

      // Calculate stats
      const totalTests = response.data.reduce((sum, app) => sum + (app.test_case_count || 0), 0);
      setStats({
        totalApps: response.data.length,
        totalTests,
      });
    } catch (error) {
      console.error('Failed to fetch apps:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p>Welcome back, {user?.username}!</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon apps-icon">📱</div>
          <div className="stat-info">
            <h3>{stats.totalApps}</h3>
            <p>Applications</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon tests-icon">🧪</div>
          <div className="stat-info">
            <h3>{stats.totalTests}</h3>
            <p>Test Cases</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon credits-icon">💳</div>
          <div className="stat-info">
            <h3>{user?.credits || 0}</h3>
            <p>Credits Available</p>
          </div>
        </div>
      </div>

      <div className="dashboard-section">
        <div className="section-header">
          <h2>Your Applications</h2>
          <Link to="/applications" className="view-all-link">View All</Link>
        </div>

        {apps.length === 0 ? (
          <div className="empty-state">
            <p>No applications yet. Get started by creating your first application!</p>
            <Link to="/applications" className="btn-primary">Create Application</Link>
          </div>
        ) : (
          <div className="apps-preview">
            {apps.slice(0, 3).map((app) => (
              <Link to={`/applications/${app.id}/testcases`} key={app.id} className="app-card">
                <h3>{app.name}</h3>
                <p className="app-url">{app.base_url}</p>
                <div className="app-meta">
                  <span>{app.test_case_count || 0} tests</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>

      <div className="quick-actions">
        <h2>Quick Actions</h2>
        <div className="actions-grid">
          <Link to="/applications" className="action-card">
            <span className="action-icon">➕</span>
            <span>New Application</span>
          </Link>
          {apps.length > 0 && (
            <Link to={`/applications/${apps[0].id}/testcases`} className="action-card">
              <span className="action-icon">🧪</span>
              <span>Generate Test</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
